<template>
    <edit></edit>
</template>
<script>
    import edit from './platform_notice_edit.vue'

    export default {
        name: 'platform_notice_add',

        components: {
            edit
        }
    }
</script>
